export default __webpack_public_path__ + "static/media/401_error_unauthorized.78f923c9.svg";